export const NOTIFICATION_CENTER_PAGE_SIZE = 20;
export const NOTIFICATION_CENTER_REPORTING_TAB_ID = "reporting";
export const NOTIFICATION_CENTER_DEADLINES_TAB_ID = "deadlines";
export const NOTIFICATION_CENTER_SETTINGS_TAB_ID = "settings";
export const NOTIFICATION_CENTER_REGISTRATIONS_TAB_ID = "registrations";
export const NOTIFICATION_CENTER_INTERMEDIARY_PAYMENTS_TAB_ID =
  "intermediary_payments";

/** Tables loaded via generic fetchNotificationCenterTable (offset/limit). Deadlines use a dedicated thunk with deadline_filter. */
export function isNotificationCenterPaginatedTable(tableId) {
  return Boolean(tableId) && tableId !== NOTIFICATION_CENTER_DEADLINES_TAB_ID;
}

export const NOTIFICATION_CENTER_TAB_KEYS = [
  "reporting",
  "messages",
  "cases",
  "charge_invoices",
  "fund_requests",
  "intermediary_payments",
  "product",
  "settings",
  "registrations",
  "deadlines",
];
